import React, { Component, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import setAuthToken from './utils/setAuthToken';
import { setCurrentUser, logoutUser } from './actions/authAction';
import UserRoute from './components/common/UserRoute';
import { Provider } from 'react-redux';
import store from './store';
import Web3 from "xdc3";
import ScrollToTop from './utils/ScrollToTop';
import './App.css';
import Landing from './components/layouts/Landing';
import Dashboard from './components/user/dashboard/Dashboard';
import Xchange from './components/user/xchange/Xchange';
const { connectWallet, createWeb3Provider, EthereumContext, createContractInstance, log } = require('react-solidity-web3');



export default function App() {
  const [ethereumContext, setethereumContext] = useState([]);

  return (
    <Provider store={store}>
      <EthereumContext.Provider value={{ ethereumContext, setethereumContext }}>
        <Router
          exact
          path="/"
        //forceRefresh={true}
        >
          <div class="nk-app-root">
            <ScrollToTop />
            {/* ADMIN ROUTE */}
            <Route exact path="/" component={Landing} />
            <Switch>
              <UserRoute exact path="/dashboard" component={Dashboard} />
              <UserRoute exact path="/xchange" component={Xchange} />
            </Switch>
          </div>
        </Router>
      </EthereumContext.Provider>
    </Provider>
  )
}

